import React from 'react';
import SignUpFormCN from './SignUpFormCN';
import Testimony from './Testimony';
import Feature from './ Feature';

function ApplyAcademic() {
  return (
    <React.Fragment>
      <div className="container trial-page">
        <div className="apply-txt pt-4">
          <div className="apply-div">
            <h1 className="pb-2">利用最可靠、最广泛的数据库加速您的研究</h1>
            <h6>
              <strong>GET YOUR FREE ACADEMIC LICENSE</strong>
            </h6>
            <h6 className="mt-4">
              Access all fundamental bioinformatics information needed for academic research, including
              well-known genes, diseases, and pathways <strong>free of charge.</strong>
            </h6>
            <div>
              <img
                src="../../../static/images/disgenetpc.png"
                alt="logo disgenet"
                style={{
                  width: '650px',
                }}
              />
            </div>
          </div>
          <div className="">
            <SignUpFormCN />
          </div>
        </div>
        <div className="testimony-div">
          <Testimony />
        </div>
        <div className="benefits">
          <Feature />
        </div>
      </div>
    </React.Fragment>
  );
}

export default ApplyAcademic;
